export default {
    FINANCE_REQUEST_ACCEPT: "FINANCE_REQUEST_ACCEPT",
    FINANCE_REQUEST_PAY: "FINANCE_REQUEST_PAY",
    FINANCE_REQUEST_EXPORT: "FINANCE_REQUEST_EXPORT",
    SPENDINGS: "SPENDINGS",
    /** Правка реестра доходов и расходов и плана накладных */
    SPENDINGS_EDIT: "SPENDINGS_EDIT",
    SPENDINGS_IMPORT: "SPENDINGS_IMPORT",
    SPENDINGS_EXPORT: "SPENDINGS_EXPORT",
};
